var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var DELETE_USER = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation DeleteUser($tenantId: String!, $electionEventId: String, $userId: String!) {\n        delete_user(tenant_id: $tenantId, election_event_id: $electionEventId, user_id: $userId) {\n            id\n        }\n    }\n"], ["\n    mutation DeleteUser($tenantId: String!, $electionEventId: String, $userId: String!) {\n        delete_user(tenant_id: $tenantId, election_event_id: $electionEventId, user_id: $userId) {\n            id\n        }\n    }\n"])));
var templateObject_1;
